import svg from "./scatterplot-bordered-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const ScatterplotApexIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.main,
);

export default ScatterplotApexIcon;
